import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=140bbbc2&"
import script from "./Page.vue?vue&type=script&lang=coffee&"
export * from "./Page.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports